const ITEMS = [
  "Giovani Adulti", "Ansia", "Esperienze Traumatiche", "Difficoltà Relazionali",
  "Crescita Personale", "Sostegno ai Familiari", "Psicoterapia Online",
];

export const Marquee = () => (
  <div className="bg-[#F3EFE6] border-y border-[#1C1E1D]/10 py-5 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif italic text-lg sm:text-xl text-[#525754] px-6">{item}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-[#C85A32]/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
